var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({ 'background-color': _vm.colorFondo }),attrs:{"id":"landing-page"}},[(_vm.access_token)?_c('menu-drawer'):_vm._e(),_c('v-main',{staticClass:"mx-0 mt-0"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }